export const FullDealEntryPointBannerTexts = {
  title: 'Первый займ бесплатно',
  badgeTitle: 'ЕСТЬ АКТИВНАЯ ЗАЯВКА',
  badgeTitleWithTime: `ПОЛУЧИТЕ ДЕНЬГИ В {time}`,
} as const;
